import React from 'react';
import CopayTerms from '../../copay/terms';
import FtoTerms from '../../fto/terms';
import { Service } from '../../../../../../hoc/context/product/configuration-model';
import { ServiceNames } from '../../../../../../hoc/constants/service.constants';

const Terms: React.FC<{service: Service}> = ({service}) => {

	return (
		<>
			{ ServiceNames.copay === service.name && <CopayTerms /> }
			{ ServiceNames.fto === service.name && <FtoTerms /> }
		</>
	);
};

export default Terms;
